<template>
    <transition>
        <div class="rule">
            <div class="tip">
                <div class="tip-title">活动提醒</div>
                <div class="tip-content">
                    <p>请关注仁翔药购网的动态哦！</p>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>
    export default {
        name: "Over",
        data() {
            return {}
        },
        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    .rule {
        width: 100%;
    }

    .tip {
        position: relative;
        margin: 8.5rem auto 0;
        width: 17.5rem;
        /*border: 1px solid #fbc27f;*/
    }

    .tip-content {
        padding: 1.5625rem 0.625rem;
        font-size: 0.875rem;
        color: #000;
        line-height: 1.5;
        /*background: #f36d56;*/
    }

    .tip-title {
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 1rem;
        color: #000;
        /*background: rgb(243, 109, 86);*/
        padding: 0.3125rem 0.625rem;
    }

</style>



// WEBPACK FOOTER //
// Over.vue?a11e3286